import React, { useState } from "react";
import { apiClient } from "../../lib/api";

const MODES = [
  { v: "browser", label: "Ring this browser only" },
  { v: "browser_and_cell", label: "Ring browser and my cell" },
  { v: "cell_first", label: "Use my cell (calls ring my cell first)" },
];

export const PhoneSettings = ({ prefs, setPrefs }) => {
  const [cell, setCell] = useState(prefs?.cell_phone || "");
  const [note, setNote] = useState(null);
  const save = async (patch) => {
    try {
      const { data } = await apiClient.put("/softphone/prefs", patch);
      setPrefs(data); setNote("saved");
    } catch (e) { setNote(e?.response?.data?.detail || "couldn't save"); }
  };
  const askNotify = async () => {
    if (!("Notification" in window)) { setNote("this browser can't show notifications"); return; }
    const p = await Notification.requestPermission();
    setNote(p === "granted" ? "desktop notifications on" : "notifications blocked in browser settings");
  };
  return (
    <div className="sp-settings" data-testid="softphone-settings">
      <div className="sp-label">When calls come to me</div>
      {MODES.map((m) => (
        <label key={m.v} className="sp-radio">
          <input type="radio" name="sp-ring" checked={prefs?.ring_mode === m.v} onChange={() => save({ ring_mode: m.v })} data-testid={`softphone-ring-mode-${m.v}`} />
          {m.label}
        </label>
      ))}
      <div className="sp-label">My cell</div>
      <div className="sp-row">
        <input className="sp-input" value={cell} onChange={(e) => setCell(e.target.value)} placeholder="+1 555 555 5555" data-testid="softphone-cell-input" />
        <button className="sp-btn" onClick={() => save({ cell_phone: cell })} data-testid="softphone-cell-save">Save</button>
      </div>
      <button className="sp-link" onClick={askNotify} data-testid="softphone-enable-notifications">Enable desktop notifications</button>
      {note && <div className="sp-note" data-testid="softphone-settings-note">{note}</div>}
    </div>
  );
};
